// extracted by mini-css-extract-plugin
export default {"title":"E_-z","warning":"F_-z","sizeOptionsLegendText":"G_-z"};